// Core
import { 
  Route, 
  Switch, 
  Redirect, 
  useRouteMatch, 
} from 'react-router-dom';

// Chakra imports
import { 
  Box,
} from '@chakra-ui/react';

// Components
import ApiKey from './ApiKey';
import ApiKeysEditEdit from './ApiKeysEditEdit';

function ApiKeys(props) {
  const { path } = useRouteMatch();

  return (
    <>
      <Box>
        <Switch>
          <Route path={`${path}/:id(new|\\d+)`} render={() => <ApiKeysEditEdit/>}/>
          <Route path={`${path}`} render={() => <ApiKey/>}/>
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default ApiKeys;